import React, { useEffect, useState } from "react";

const EnglishQuizTimer = ({
  durationMinutes = 0,
  startedAt,
  onTimeUp,
}) => {
  const calculateRemainingSeconds = () => {
    if (!durationMinutes) {
      return 0;
    }

    if (!startedAt) {
      return durationMinutes * 60;
    }

    const startTime =
      new Date(startedAt).getTime();

    const endTime =
      startTime +
      durationMinutes * 60 * 1000;

    const remaining =
      Math.floor(
        (endTime - Date.now()) / 1000,
      );

    return Math.max(0, remaining);
  };

  const [remainingSeconds, setRemainingSeconds] =
    useState(calculateRemainingSeconds);

  useEffect(() => {
    const timer = setInterval(() => {
      const remaining =
        calculateRemainingSeconds();

      setRemainingSeconds(remaining);

      if (remaining <= 0) {
        clearInterval(timer);

        if (onTimeUp) {
          onTimeUp();
        }
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [durationMinutes, startedAt, onTimeUp]);

  const minutes = Math.floor(
    remainingSeconds / 60,
  );

  const seconds =
    remainingSeconds % 60;

  const isLowTime =
    remainingSeconds <= 60;

  return (
    <div
      className={`
        rounded-xl
        px-5
        py-3
        text-center
        font-semibold
        ${
          isLowTime
            ? "bg-red-100 text-red-700"
            : "bg-blue-100 text-blue-700"
        }
      `}
    >
      <p className="text-sm">
        Time Remaining
      </p>

      <p className="mt-1 text-2xl font-bold">
        {String(minutes).padStart(2, "0")}:
        {String(seconds).padStart(2, "0")}
      </p>
    </div>
  );
};

export default EnglishQuizTimer;